// Formatera ett kr/kg-pris till vald visningsenhet (hg, kg eller st).
// Används på publika produktsidor för att visa enhetligt per produkt.
export const formatProductPrice = (pricePerKg, displayUnit = 'hg') => {
  if (pricePerKg === null || pricePerKg === undefined || pricePerKg === '') return null;
  const p = parseFloat(pricePerKg);
  if (!Number.isFinite(p)) return null;
  const fmt = (n) => n.toFixed(2).replace(/\.?0+$/, '').replace('.', ',');
  if (displayUnit === 'hg') return `${fmt(p / 10)} kr/hg`;
  if (displayUnit === 'kg') return `${fmt(p)} kr/kg`;
  if (displayUnit === 'st') return `${fmt(p)} kr/st`;
  return `${fmt(p)} kr`;
};

export const PRICE_UNITS = [
  { value: 'hg', label: 'per hg (100 g)' },
  { value: 'kg', label: 'per kg' },
  { value: 'st', label: 'per styck' },
];
